module.exports = __webpack_public_path__ + "img/20190313.99dafcc2.png";